import { rgba } from 'polished';
import { colors } from './colors';

export const boxShadowInput = `inset 0 1px 2px 0 rgba(0,0,0,.2)`;
export const boxShadowHover = `0 1px 0 0 ${colors.border.hover}`;
export const boxShadowMedium = `0 1px 0 0 ${colors.border.medium}`;
export const boxShadowTooltip = `0 0.125rem 0.3125rem ${rgba(
  colors.border.dark,
  0.5
)}`;
export const boxShadowTooltipArrow = `0 0 1px ${rgba(colors.border.dark, 0.5)}`;

export const standardBorder = `1px solid ${colors.border.medium}`;
export const transparentBorder = '1px solid transparent';
